import { render } from "./BrandsTable.vue?vue&type=template&id=2e090ecc"
import script from "./BrandsTable.vue?vue&type=script&lang=js"
export * from "./BrandsTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./BrandsTable.vue?vue&type=style&index=0&id=2e090ecc&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script